import React, { useState } from 'react'
import { FileUploader } from 'react-drag-drop-files'
import { alert } from '../../../utils/helper'

type DragDropProps = {
  setFile: any
  label?: string
  fileTypes: string[]
  file?: File | null
  customDragDropSection?: React.ReactNode
  disabled?: boolean
}

function DragDrop({
  setFile,
  label,
  file,
  fileTypes,
  customDragDropSection,
  disabled = false
}: DragDropProps) {

  const [key, setKey] = useState(0)
  const [typeError, setTypeError] = useState<string | null>(null)

  const handleChange = (uploadedFile: any) => {
    if (!uploadedFile) return

    setTypeError(null)

    const fileName = uploadedFile.name
    const nameWithoutExtension =
      fileName.substring(0, fileName.lastIndexOf(".")) || fileName

    const validNameRegex = /^[a-zA-Z0-9._\-\s]+$/

    if (!validNameRegex.test(nameWithoutExtension)) {
      alert(`File name contains invalid special characters`, 'warning')
      setFile(null)
      setKey(prev => prev + 1)
      return
    }
    setFile(uploadedFile)
  }

  const handleTypeError = () => {
    alert(`File type error, use ${fileTypes.join(', ')} only!`, 'warning')
    setTypeError(`File type error, use ${fileTypes.join(', ')} only!`)
    setKey(prev => prev + 1)
  }

  return (
    <div>
      <FileUploader
        disabled={disabled}
        key={key}
        classes='h-60px bg-gray-100 border-gray-500 w-40'
        label={label}
        file={file}
        handleChange={handleChange}
        onTypeError={handleTypeError}
        name='file'
        types={fileTypes}
        {...(customDragDropSection ? { children: customDragDropSection } : {})}
      />
      {disabled && (
        <p className="text-danger fs-6 mt-1">
          Enter document name to enable upload
        </p>
      )}
      {typeError && !disabled && (
        <p className="text-danger fs-6 mt-1">
          {typeError}
        </p>
      )}
    </div>
  )
}

export default DragDrop